var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56901 1.83333C4.78665 1.06383 5.49414 0.5 6.33333 0.5H7.66666C8.50585 0.5 9.21334 1.06383 9.43098 1.83333H10.3333C11.3459 1.83333 12.1667 2.65414 12.1667 3.66667V11.6667C12.1667 12.6792 11.3459 13.5 10.3333 13.5H3.66666C2.65414 13.5 1.83333 12.6792 1.83333 11.6667V3.66667C1.83333 2.65414 2.65414 1.83333 3.66666 1.83333H4.56901ZM4.56901 2.83333H3.66666C3.20642 2.83333 2.83333 3.20643 2.83333 3.66667V11.6667C2.83333 12.1269 3.20642 12.5 3.66666 12.5H10.3333C10.7936 12.5 11.1667 12.1269 11.1667 11.6667V3.66667C11.1667 3.20643 10.7936 2.83333 10.3333 2.83333H9.43098C9.21334 3.60284 8.50585 4.16667 7.66666 4.16667H6.33333C5.49414 4.16667 4.78665 3.60284 4.56901 2.83333ZM6.33333 1.5C5.87309 1.5 5.49999 1.8731 5.49999 2.33333C5.49999 2.79357 5.87309 3.16667 6.33333 3.16667H7.66666C8.1269 3.16667 8.5 2.79357 8.5 2.33333C8.5 1.8731 8.1269 1.5 7.66666 1.5H6.33333Z",
    fill: "#051123",
    stroke: "#051123",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToList);
export default __webpack_public_path__ + "static/media/add_to_list.43ff68cf6cad02c64afe252654c15459.svg";
export { ForwardRef as ReactComponent };